// Tiny IndexedDB wrapper for storing recording Blobs against outbox item ids.
// localStorage can't hold Blobs, and base64-in-localStorage is wasteful for
// audio. IDB gives us arbitrary-size binary storage persistent across reloads.

const DB_NAME = 'hive-blobs';
const DB_VERSION = 1;
const STORE = 'audio';

let dbPromise: Promise<IDBDatabase> | null = null;

function openDb(): Promise<IDBDatabase> {
  if (!dbPromise) {
    dbPromise = new Promise((resolve, reject) => {
      const req = indexedDB.open(DB_NAME, DB_VERSION);
      req.onupgradeneeded = () => {
        const db = req.result;
        if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE);
      };
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  }
  return dbPromise;
}

function tx<T>(mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  return openDb().then(
    (db) =>
      new Promise<T>((resolve, reject) => {
        const t = db.transaction(STORE, mode);
        const s = t.objectStore(STORE);
        const req = fn(s);
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
      })
  );
}

export function putBlob(key: string, blob: Blob): Promise<IDBValidKey> {
  return tx('readwrite', (s) => s.put(blob, key));
}

export function getBlob(key: string): Promise<Blob | undefined> {
  return tx<Blob | undefined>('readonly', (s) => s.get(key) as IDBRequest<Blob | undefined>);
}

export function deleteBlob(key: string): Promise<undefined> {
  return tx<undefined>('readwrite', (s) => s.delete(key) as IDBRequest<undefined>);
}
